import { EPlacingType } from '../../../../../redux/reducers';
import { IPublishOptionSchema } from '../../internalTypes';

export function getSelectedPlacingType(
  periods: IPublishOptionSchema[],
  packages: IPublishOptionSchema[],
): EPlacingType {
  const hasPaidPeriod = !!periods.find(({ isPaid }) => isPaid);
  const hasPackages = packages.length > 0;

  if (hasPaidPeriod || !hasPackages) {
    return EPlacingType.balance;
  }

  return EPlacingType.package;
}
